import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteSingleSelect, renderDateField } from '../../../../../components/reduxFields';
import { REPORT_URL, base64Encode } from '../../../../../actions/utilAction';
import Loader from '../../../../../img/loader.gif';

class KronosPayrollWithTotalMileageReport extends Component {
  constructor(props) {
    super(props);
    this.state = {     
      access_token: this.props.access_token, 
      FromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      ToDate: new Date(),      
      iframeURL: '',
      isLoading: false,
      random: 0,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.FilterByDate = this.FilterByDate.bind(this);
  }

    onDateChange = (input, value) => {
      input.onChange(moment(value).format());
      this.setState({
        [input.name]: value,
      });
    }

    FilterByDate = (formData) => {
      this.resetIframe();

      let FromDateFormat;
      let ToDateFormat;
      let DateFormat;
      let dateFormat;

      if (Object.keys(formData).length) {
        FromDateFormat = moment(this.state.FromDate).format('YYYY-MM-DD');
        ToDateFormat = moment(this.state.ToDate).format('YYYY-MM-DD');
      } else {
        DateFormat = new Date().setDate(new Date().getDate() - 7);
        FromDateFormat = moment(DateFormat).format('YYYY-MM-DD');
        dateFormat = new Date();
        ToDateFormat = moment(dateFormat).format('YYYY-MM-DD');
      }
      let reportName = base64Encode('FC_KronosCustomPayrollWithTotalMileage_RPT');
      this.setState({
        isLoading: true,
        iframeURL: `${REPORT_URL}?Params=[{"Name": "FromAppointmentDate","Value": "`+ FromDateFormat + `"},{"Name": "ToAppointmentDate","Value": "`+ ToDateFormat + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
      });
    }

    onLoadReport = (e) => {
      this.setState({ isLoading: false});
    }

    resetIframe() {
      this.setState({random: this.state.random + 1});
    }

  handleChange = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }

  render() {
    const { handleSubmit } = this.props;
    
    return (
      <div>
        {this.renderLoading()}
        <h2 className="page_title">Kronos Payroll With Total Mileage Report</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.FilterByDate)}>
              <div className="row">
                <div className="col-sm-4">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />

                </div>
                <div className="col-sm-4">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    // minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
                <div className="col-sm-4 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Iframe url={this.state.iframeURL}
          // width="450px"
          height="580px"
          id="myId"
          className="manual_report"
          display="initial"
          position="relative"
          onLoad={(e)=> this.onLoadReport(e)}
          key={this.state.random}
          allowFullScreen />
      </div>
    );
  }
}

KronosPayrollWithTotalMileageReport = reduxForm({
  form: 'KronosPayrollWithTotalMileageReportForm',
})(KronosPayrollWithTotalMileageReport);

function mapStateToProps(state) {    
  return {            
    access_token: state.superadminLogin.access_token,
  };
}
export default connect(mapStateToProps)(KronosPayrollWithTotalMileageReport);



// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/Reports/components/KronosPayrollWithTotalMileageReport.js